module.exports = wtr_shared_19_3_1;